/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type OAuthAppCreationTypeEnum = 'DYNAMIC' | 'STATIC';

export const OAuthAppCreationTypeEnum = {

    DYNAMIC: 'DYNAMIC' as OAuthAppCreationTypeEnum,

    STATIC: 'STATIC' as OAuthAppCreationTypeEnum
};

